import {
  GET_PATCH_CATEGORY_SEVERITY,
  GET_PATCH_APPROVAL_STATUS_META
} from '@nile/rmm/src/modules/patch-management/Graphql/patch';
import {
  GET_BIT_LOCKER_STATUSES,
  GET_PATCH_STATUSES,
  GET_ASSET_LIST_V2,
  GET_MONITORED_ASSET_CLASS_LIST,
  GET_SOFTWARENAME_LIST
} from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { GET_ASSET_CLASS_LIST_V2 } from '@nile/banyan/src/Graphql/Query/asset';
import {
  GET_POLICY_TYPES,
  GET_UNIQUE_POLICY_NAMES
} from '@nile/rmm/src/modules/alert-management/Graphql/alert';
import {
  RMMClient,
  AccountClient,
  TicketClient,
  GET_PAYMENT_METHOD
} from '@nile/graphql';
import { GET_SCRIPTS_META_V2 } from '@nile/rmm/src/modules/scripts/Graphql';
import {
  GET_ROLES,
  GET_TECHNICIAN_ROLES
} from '@nile/banyan/src/Graphql/Mutations/role';
import { GET_ALERT_SEVERITY_LIST } from '@nile/banyan/src/Graphql/Query/policy';
import { GET_SERVICE_ITEMS } from '@nile/graphql/src/Query/serviceCatalog';
import { GET_WHITELISTED_SERVICE_ITEMS_LIST } from '@nile/graphql/src/Query/worklog/worklog';
import { GET_NETWORK_CREDENTIAL_LIST } from '@nile/rmm/src/snmp/SnmpQuery';
import {
  GET_ACTIVE_RECURRING_REVENUE,
  GET_CLIENT_EFFICIENCY_RANKING,
  GET_CLIENT_FINANCIAL_PERFORMANCE,
  GET_CLIENT_SPECIFIC_EFFICIENCY,
  GET_CONTRACT_FINANCIAL_PERFORMANCE,
  GET_CRE_COMPANY_BASELINE,
  GET_CRE_TREND_ANALYSIS,
  GET_FILTER_INPUTS,
  GET_LABOUR_REVENUE,
  GET_MONTHLY_LABOUR_REVENUE,
  GET_MOTHLY_REVENUE,
  GET_SERVICE_UTILISATION,
  GET_TECHNICIAN_UTILISATION,
  GET_TICKET_LIST_CRE,
  GET_TOP_CLIENTS_BY_FINANCE,
  GET_TOP_CONTRACTS_BY_FINANCE,
  GET_WORKLOG_HOURS_LOGGED
} from '@nile/reports/src/modules/EfficiencyReport/graphql';
import {
  GET_COMMUNITY_SCRIPT_TAGS,
  GET_COMMUNITY_LIBRARY_SCRIPTS
} from '@nile/rmm/src/modules/script-library/Graphql/script-library';
import { GET_CLIENT_SITE_LIST_FOR_DROPDOWN } from '@nile/banyan/src/Graphql/Mutations/site';
import { GET_CLIENTS } from '../Mutation/client';
import { GET_CLIENT_USERS } from '../Query/client';
import { GET_ALL_WORK_STATUSES } from '../Query/projects';
import { GET_ALL_SOP } from '../Query/sop';
import {
  GET_REQUESTERS_BY_CRITERIA,
  GET_TECHNICIANS_BY_CRITERIA
} from '../Query/automationrules';
import {
  GET_ALLOWED_TECHNICIAN_GROUPS,
  GET_ALL_TECHS_NEW,
  GET_ALL_TECH_GROUP
} from '../Query/techgroup';
import { GET_FIELD, GET_TICKET_APPROVAL_STATUS } from '../Query/ticketfields';
import { GET_ASSET_LIST, GET_SOURCES } from '../Query/ticket';
import {
  ALL_MODULES,
  DEFAULT_FIELDS_BY_COLUMN_NAME
} from '../../../components/src/Constants/index';
import {
  GET_WORKLOG_MODULE,
  GET_OFFERED_ITEMS_MODULE,
  GET_INVOICE_STATUS,
  GET_THIRDPARTY_INTEGRATED_APP_STATUS,
  GET_INVOICE_PAYMENT_METHODS,
  GET_INVOICE_PAYMENT_TERMS
} from '../Query/client_management/invoice';
import {
  GET_ALLMSP_DESIGNATIONS,
  GET_MSP_BUSINESSFUNCTIONS,
  GET_MSP_TEAMLIST
} from '@nile/graphql/src/Query/employee';
import {
  GET_ELIGIBLE_SERVICE_ITEMS,
  GET_SERVICE_CATALOG_ITEMS_FOR_RULE_BUILDER
} from '@nile/graphql/src/Query/serviceCatalogNew';

import {
  GET_CLIENT_PROVISION_RULE_LIST,
  GET_TEMPLATE_PROVISION_RULE_LIST
} from '@nile/graphql/src/Query/contracts';
import { GET_COMPANY_USERS } from '@nile/graphql/src/Query/automationrules';

import { GET_RUNBOOKS_FOR_DROPDOWN } from '@nile/graphql/src/Query/Unified_Runbook/index.js';
import { GET_TICKET_FORM_FOR_DROPDOWN } from '@nile/graphql/src/Query/ticketforms.js';
/**
 * APIs to call based on selected properties
 */

// Default sort parameter for site-related API calls
const DEFAULT_SITE_SORT = [
  {
    attribute: 'name',
    order: 'ASC'
  }
];

// Global variable for default site sort configuration
const DEFAULT_SITE_SORT_CONFIG = {
  input: {
    sort: DEFAULT_SITE_SORT
  }
};

const apiResolver = {
  Ticket: {
    subject: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
        }
      }
    },
    department: {
      api: GET_MSP_BUSINESSFUNCTIONS,
      client: AccountClient,
      variables: {}
    },
    'department.name': {
      api: GET_MSP_BUSINESSFUNCTIONS,
      client: AccountClient,
      variables: {}
    },
    status: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
        }
      }
    },
    approvalStatus: {
      api: GET_TICKET_APPROVAL_STATUS,
      client: TicketClient
    },
    priority: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.PRIORITY
        }
      }
    },
    impact: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.IMPACT
        }
      }
    },
    urgency: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.URGENCY
        }
      }
    },
    category: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.CATEGORY
        }
      }
    },
    subcategory: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.SUB_CATEGORY
        }
      }
    },
    cause: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.CAUSE
        }
      }
    },
    subcause: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.SUB_CAUSE
        }
      }
    },
    resolutionCode: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.RESOLUTION_CODE
        }
      }
    },
    ticketType: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.TICKET_TYPE
        }
      }
    },
    client: {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'client.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    site: {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    technician: {
      api: GET_ALLOWED_TECHNICIAN_GROUPS,
      client: AccountClient
    },
    techGroup: {
      api: GET_ALLOWED_TECHNICIAN_GROUPS,
      client: AccountClient
    },
    'techGroup.name': {
      api: GET_ALL_TECH_GROUP,
      client: AccountClient
    },
    sop: {
      api: GET_ALL_SOP,
      client: TicketClient
    },
    RUNBOOK: {
      api: GET_RUNBOOKS_FOR_DROPDOWN,
      client: TicketClient,
      variables: {
        input: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          },
          condition: {
            attribute: 'status',
            operator: 'is',
            value: 'ACTIVE'
          }
        }
      }
    },
    source: {
      api: GET_SOURCES,
      client: TicketClient
    },
    tUdf1: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
        }
      }
    },
    team: {
      api: GET_MSP_TEAMLIST,
      client: AccountClient
    },
    businessFunction: {
      api: GET_MSP_BUSINESSFUNCTIONS,
      client: AccountClient
    },
    designation: {
      api: GET_ALLMSP_DESIGNATIONS,
      client: AccountClient
    },
    reportingManager: {
      api: GET_COMPANY_USERS,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    roles: {
      api: GET_TECHNICIAN_ROLES,
      client: AccountClient
    },
    'ticket.form': {
      api: GET_TICKET_FORM_FOR_DROPDOWN,
      client: TicketClient
    }
  },
  Client: {
    name: {
      api: GET_CLIENTS,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    stage: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.client,
          columnName: 'stage'
        }
      }
    },
    status: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.client,
          columnName: 'status'
        }
      }
    },
    role: {
      api: GET_ROLES,
      client: AccountClient
    },
    client: {
      api: GET_CLIENTS,
      client: AccountClient
    },
    site: {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'primaryContact.name': {
      api: GET_REQUESTERS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    'primaryContact.email': {
      api: GET_REQUESTERS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    'secondaryContact.name': {
      api: GET_REQUESTERS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    'secondaryContact.email': {
      api: GET_REQUESTERS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    'accountManager.email': {
      api: GET_TECHNICIANS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    },
    'accountManager.name': {
      api: GET_TECHNICIANS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    },
    getRequesterName: {
      api: GET_REQUESTERS_BY_CRITERIA,
      client: AccountClient
    },

    getTechName: {
      api: GET_TECHNICIANS_BY_CRITERIA,
      client: AccountClient
    },
    getRequesterEmail: {
      api: GET_REQUESTERS_BY_CRITERIA,
      client: AccountClient
    },

    getTechEmail: {
      api: GET_TECHNICIANS_BY_CRITERIA,
      client: AccountClient
    }
  },
  Task: {
    status: {
      api: GET_ALL_WORK_STATUSES,
      client: TicketClient
    },
    techGroup: {
      api: GET_ALL_TECH_GROUP,
      client: AccountClient
    },
    'techGroup.name': {
      api: GET_ALL_TECH_GROUP,
      client: AccountClient
    },
    'workItem.client': {
      api: GET_CLIENTS,
      client: AccountClient,
      variables: {
        listInfo: {}
      }
    },
    'workItem.client.name': {
      api: GET_CLIENTS,
      client: AccountClient,
      variables: {
        listInfo: {}
      }
    },
    'workItem.site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    priority: {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.task,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.PRIORITY
        }
      }
    },
    'entity.task.priority': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.task,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.PRIORITY
        }
      }
    }
  },
  Project: {
    client: {
      api: GET_CLIENTS,
      client: AccountClient
    },
    status: {
      api: GET_ALL_WORK_STATUSES,
      client: TicketClient
    },
    site: {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    owner: {
      api: GET_ALL_TECHS_NEW,
      client: AccountClient,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    }
  },
  Worklog: {
    'project.status': {
      api: GET_ALL_WORK_STATUSES,
      client: TicketClient
    },
    'project.techGroup.name': {
      api: GET_ALL_TECH_GROUP,
      client: AccountClient
    },
    'ticket.techGroup.name': {
      api: GET_ALL_TECH_GROUP,
      client: AccountClient
    },
    'worklog.client.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'ticket.status': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
        }
      }
    },
    'ticket.approvalStatus': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
        }
      }
    },
    'ticket.priority': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.PRIORITY
        }
      }
    },
    'ticket.impact': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.IMPACT
        }
      }
    },
    'ticket.urgency': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.URGENCY
        }
      }
    },
    'ticket.category': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.CATEGORY
        }
      }
    },
    'ticket.subcategory': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.SUB_CATEGORY
        }
      }
    },
    'ticket.cause': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.CAUSE
        }
      }
    },
    'ticket.subcause': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.SUB_CAUSE
        }
      }
    },
    'ticket.resolutionCode': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.RESOLUTION_CODE
        }
      }
    },
    'ticket.ticketType': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.TICKET_TYPE
        }
      }
    },
    'ticket.sop': {
      api: GET_ALL_SOP,
      client: TicketClient
    },
    RUNBOOK: {
      api: GET_RUNBOOKS_FOR_DROPDOWN,
      client: TicketClient,
      variables: {
        input: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          },
          condition: {
            attribute: 'status',
            operator: 'is',
            value: 'ACTIVE'
          }
        }
      }
    },
    'ticket.source': {
      api: GET_SOURCES,
      client: TicketClient
    }
  },
  Patch: {
    'workStation.client.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'workStation.site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient
    },
    category: {
      api: GET_PATCH_CATEGORY_SEVERITY,
      client: RMMClient
    },
    'patchDetail.category': {
      api: GET_PATCH_CATEGORY_SEVERITY,
      client: RMMClient
    },
    severity: {
      api: GET_PATCH_CATEGORY_SEVERITY,
      client: RMMClient
    },
    'patchDetail.severity': {
      api: GET_PATCH_CATEGORY_SEVERITY,
      client: RMMClient
    },
    'account.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    approvalStatus: {
      api: GET_PATCH_APPROVAL_STATUS_META,
      client: RMMClient
    },
    'patchDetail.approvalStatus': {
      api: GET_PATCH_APPROVAL_STATUS_META,
      client: RMMClient
    },
    'assetClass.name': {
      api: GET_MONITORED_ASSET_CLASS_LIST,
      client: RMMClient
    }
  },
  AssetPatch: {
    'patchDetail.category': {
      api: GET_PATCH_CATEGORY_SEVERITY,
      client: RMMClient
    },
    'patchDetail.severity': {
      api: GET_PATCH_CATEGORY_SEVERITY,
      client: RMMClient
    },
    approvalStatus: {
      api: GET_PATCH_APPROVAL_STATUS_META,
      client: RMMClient
    },
    'patchDetail.approvalStatus': {
      api: GET_PATCH_APPROVAL_STATUS_META,
      client: RMMClient
    }
  },
  Policy: {
    'policy.policyType': {
      api: GET_POLICY_TYPES,
      client: RMMClient
    }
  },
  Alert: {
    'asset.client.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'asset.site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'client.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'policy.name': {
      api: GET_UNIQUE_POLICY_NAMES,
      client: RMMClient
    },
    'policy.policyType': {
      api: GET_POLICY_TYPES,
      client: RMMClient
    },
    severity: {
      api: GET_ALERT_SEVERITY_LIST,
      client: RMMClient
    }
  },
  Asset: {
    'client.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    department: {
      api: GET_MSP_BUSINESSFUNCTIONS,
      client: AccountClient,
      variables: {}
    },
    'department.name': {
      api: GET_MSP_BUSINESSFUNCTIONS,
      client: AccountClient,
      variables: {}
    },
    'asset.client.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'asset.site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'workStation.client.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'workStation.site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    bitLockerStatus: {
      api: GET_BIT_LOCKER_STATUSES,
      client: RMMClient
    },
    patchStatus: {
      api: GET_PATCH_STATUSES,
      client: RMMClient
    },
    'patchDetail.category': {
      api: GET_PATCH_CATEGORY_SEVERITY,
      client: RMMClient
    },
    'patchDetail.severity': {
      api: GET_PATCH_CATEGORY_SEVERITY,
      client: RMMClient
    },
    approvalStatus: {
      api: GET_PATCH_APPROVAL_STATUS_META,
      client: RMMClient
    },
    'patchDetail.approvalStatus': {
      api: GET_PATCH_APPROVAL_STATUS_META,
      client: RMMClient
    },
    'assetClass.name': {
      api: GET_ASSET_CLASS_LIST_V2,
      client: RMMClient
    },
    'asset.assetClass.name': {
      api: GET_ASSET_CLASS_LIST_V2,
      client: RMMClient
    },
    'workStation.assetClass.name': {
      api: GET_ASSET_CLASS_LIST_V2,
      client: RMMClient
    },
    'owner.name': {
      api: GET_REQUESTERS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    'requester.name': {
      api: GET_REQUESTERS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    }
  },
  AssetGroup: {
    'client.accountId': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    department: {
      api: GET_MSP_BUSINESSFUNCTIONS,
      client: AccountClient,
      variables: {}
    },
    'department.name': {
      api: GET_MSP_BUSINESSFUNCTIONS,
      client: AccountClient,
      variables: {}
    },
    'site.id': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'client.name': {
      api: GET_CLIENTS,
      client: AccountClient
    },
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    assetId: {
      api: GET_ASSET_LIST_V2,
      client: RMMClient
    },
    'assetClass.name': {
      api: GET_MONITORED_ASSET_CLASS_LIST,
      client: RMMClient
    }
  },
  Script: {
    language: {
      api: GET_SCRIPTS_META_V2,
      client: RMMClient
    },
    runAs: {
      api: GET_SCRIPTS_META_V2,
      client: RMMClient
    },
    addedBy: {
      api: GET_ALL_TECHS_NEW,
      client: AccountClient,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    },
    tags: {
      api: GET_COMMUNITY_SCRIPT_TAGS,
      client: RMMClient
    }
  },
  CommunityScript: {
    name: {
      api: GET_COMMUNITY_LIBRARY_SCRIPTS,
      client: RMMClient
    },
    language: {
      api: GET_SCRIPTS_META_V2,
      client: RMMClient
    },
    runAs: {
      api: GET_SCRIPTS_META_V2,
      client: RMMClient
    },
    addedBy: {
      api: GET_ALL_TECHS_NEW,
      client: AccountClient,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    },
    tags: {
      api: GET_COMMUNITY_SCRIPT_TAGS,
      client: RMMClient
    }
  },
  Invoice: {
    statusEnum: {
      api: GET_INVOICE_STATUS,
      client: AccountClient
    },
    pushedToIntegratedAppStatus: {
      api: GET_THIRDPARTY_INTEGRATED_APP_STATUS,
      client: AccountClient
    }
  },
  PaymentMethod: {
    paymentMethodName: {
      api: GET_INVOICE_PAYMENT_METHODS,
      client: AccountClient
    }
  },
  InvoicePaymentTerm: {
    paymentTermName: {
      api: GET_INVOICE_PAYMENT_TERMS,
      client: AccountClient
    }
  },
  OfferedItem: {
    'client.name': {
      api: GET_CLIENTS,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'serviceItem.name': {
      api: GET_SERVICE_ITEMS,
      client: AccountClient
    },
    'serviceCatalogItem.name': {
      api: GET_SERVICE_CATALOG_ITEMS_FOR_RULE_BUILDER,
      client: AccountClient,
      variables: {
        listInfo: {}
      }
    },
    'technician.email': {
      api: GET_TECHNICIANS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    },
    'technician.name': {
      api: GET_TECHNICIANS_BY_CRITERIA,
      client: AccountClient,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    },
    'ticket.status': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
        }
      }
    },
    'project.status': {
      api: GET_ALL_WORK_STATUSES,
      client: TicketClient
    },
    offeredItemModule: {
      api: GET_OFFERED_ITEMS_MODULE,
      client: AccountClient
    },
    worklogModule: {
      api: GET_WORKLOG_MODULE,
      client: AccountClient
    }
  },
  whiteListedServiceItem: {
    'serviceItem.name': {
      api: GET_WHITELISTED_SERVICE_ITEMS_LIST,
      client: AccountClient
    },
    'serviceCatalogItem.name': {
      api: GET_ELIGIBLE_SERVICE_ITEMS,
      client: AccountClient
    }
  },
  DiscoveredAssets: {
    'credential.name': {
      api: GET_NETWORK_CREDENTIAL_LIST,
      client: RMMClient
    }
  },
  WorklogEntry: {
    'client.name': {
      api: GET_CLIENTS,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'project.status': {
      api: GET_ALL_WORK_STATUSES,
      client: TicketClient
    },
    'ticket.status': {
      api: GET_FIELD,
      client: AccountClient,
      variables: {
        input: {
          module: ALL_MODULES.ticket,
          columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
        }
      }
    },
    module: {
      api: GET_WORKLOG_MODULE,
      client: AccountClient
    },
    'serviceItem.name': {
      api: GET_SERVICE_ITEMS,
      client: AccountClient
    }
  },
  Common: {
    'businessFunction.name': {
      api: GET_MSP_BUSINESSFUNCTIONS,
      client: AccountClient
    },
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    designation: {
      api: GET_ALLMSP_DESIGNATIONS,
      client: AccountClient
    },
    'designation.name': {
      api: GET_ALLMSP_DESIGNATIONS,
      client: AccountClient
    },
    getCRECompanyBaselineMetrics: {
      api: GET_CRE_COMPANY_BASELINE,
      client: AccountClient
    },
    getCustomFilterValues: {
      api: GET_FILTER_INPUTS,
      client: AccountClient
    },
    getClientRankingByWorklogHoursLogged: {
      api: GET_WORKLOG_HOURS_LOGGED,
      client: AccountClient
    },
    getClientSpecificEfficiency: {
      api: GET_CLIENT_SPECIFIC_EFFICIENCY,
      client: AccountClient
    },
    getClientEfficiencyRanking: {
      api: GET_CLIENT_EFFICIENCY_RANKING,
      client: AccountClient
    },
    getCRETrendAnalysis: {
      api: GET_CRE_TREND_ANALYSIS,
      client: AccountClient
    },
    getCRETicketsByCategory: {
      api: GET_TICKET_LIST_CRE,
      client: AccountClient
    },
    getActiveRecurringRevenue: {
      api: GET_ACTIVE_RECURRING_REVENUE,
      client: AccountClient
    },
    getMonthlyRevenue: {
      api: GET_MOTHLY_REVENUE,
      client: AccountClient
    },
    getTopClientsByFinancialSegments: {
      api: GET_TOP_CLIENTS_BY_FINANCE,
      client: AccountClient
    },
    getClientFinancialPerformanceMetrics: {
      api: GET_CLIENT_FINANCIAL_PERFORMANCE,
      client: AccountClient
    },
    getTopContractsByFinancialSegments: {
      api: GET_TOP_CONTRACTS_BY_FINANCE,
      client: AccountClient
    },
    getContractFinancialPerformanceMetrics: {
      api: GET_CONTRACT_FINANCIAL_PERFORMANCE,
      client: AccountClient
    },
    getLabourRevenue: {
      api: GET_LABOUR_REVENUE,
      client: AccountClient
    },
    getMonthlyLabourRevenue: {
      api: GET_MONTHLY_LABOUR_REVENUE,
      client: AccountClient
    },
    getServiceUtilisation: {
      api: GET_SERVICE_UTILISATION,
      client: AccountClient
    },
    getTechnicianUtilisation: {
      api: GET_TECHNICIAN_UTILISATION,
      client: AccountClient
    }
  },
  Site: {
    name: {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    }
  },
  Requester: {
    'site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    },
    'associations.site.name': {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    }
  },
  AssetClass: {
    name: {
      api: GET_ASSET_CLASS_LIST_V2,
      client: RMMClient
    }
  },
  ProvisionRule: {
    name: {
      api: GET_CLIENT_PROVISION_RULE_LIST,
      client: AccountClient
    },
    'name.in.template': {
      api: GET_TEMPLATE_PROVISION_RULE_LIST,
      client: AccountClient
    }
  },
  TechnicianGroup: {
    name: {
      api: GET_ALL_TECH_GROUP,
      client: AccountClient
    }
  },
  Site: {
    name: {
      api: GET_CLIENT_SITE_LIST_FOR_DROPDOWN,
      client: AccountClient,
      variables: DEFAULT_SITE_SORT_CONFIG
    }
  },
  ProjectOwner: {
    name: {
      api: GET_ALL_TECHS_NEW,
      client: AccountClient,
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    }
  }
};

const taskApiMethodAndKeyNames = {
  status: {
    method: 'getWorkStatuses',
    key: 'name'
  },
  priority: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'entity.task.priority': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  techGroup: {
    method: 'getTechnicianGroups',
    key: 'name'
  },
  'techGroup.name': {
    method: 'getTechnicianGroups',
    key: 'name'
  },
  'workItem.client': {
    method: 'getClientList',
    secondaryMethod: 'clients',
    key: 'name',
    values: 'clients'
  },
  'workItem.client.name': {
    method: 'getClientList',
    secondaryMethod: 'clients',
    key: 'name',
    values: 'clients'
  },
  'workItem.site.name': {
    method: 'getClientSiteList',
    key: 'name',
    secondaryMethod: 'sites'
  }
};

const projectApiMethodAndKeyNames = {
  status: {
    method: 'getWorkStatuses',
    key: 'name'
  },
  client: {
    method: 'getClientList',
    secondaryMethod: 'clients',
    key: 'name',
    values: 'clients'
  },
  site: {
    method: 'getClientSiteList',
    key: 'name',
    secondaryMethod: 'sites'
  },
  owner: {
    method: 'getTechnicianList',
    secondaryMethod: 'userList',
    key: 'name'
  }
};

// 'asset.client.name' & 'asset.site.name' can be removed once rule builder new wrapper is integrated
const alertApiMethodAndKeyNames = {
  name: {
    method: 'getWorkStationList',
    key: 'name',
    nestedKey: 'assets'
  },
  'asset.client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  'client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  'asset.site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  },
  'site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  },
  'policy.name': {
    method: 'getUniquePolicyNames'
  },
  'policy.policyType': {
    method: 'getPolicyTypes',
    key: 'name'
  },
  severity: {
    method: 'getAlertSeverityTypes',
    key: 'name'
  }
};

const assetApiMethodAndKeyNames = {
  name: {
    method: 'getWorkStationList',
    key: 'name',
    nestedKey: 'assets'
  },
  department: {
    method: 'getBusinessFunctionList',
    key: 'name'
  },
  'department.name': {
    method: 'getBusinessFunctionList',
    key: 'name'
  },
  'asset.name': {
    method: 'getWorkStationList',
    key: 'name',
    nestedKey: 'assets'
  },
  'client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  'site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites',
    secondaryMethod: 'sites'
  },
  'asset.client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  'asset.site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  },
  'workStation.client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  'workStation.site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  },
  'assetSoftware.name': {
    method: 'getAssetSoftwareNamesList'
  },
  bitLockerStatus: {
    method: 'getAssetBitLockerStatuses'
  },
  patchStatus: {
    method: 'getAssetPatchStatusMetaInfo'
  },
  'patchDetail.category': {
    method: 'getPatchAllCategorySeverityMeta',
    key: 'name',
    nestedData: 'categories'
  },
  'patchDetail.severity': {
    method: 'getPatchAllCategorySeverityMeta',
    key: 'name',
    nestedData: 'severities'
  },
  approvalStatus: {
    method: 'getPatchApprovalStatusMeta'
  },
  'patchDetail.approvalStatus': {
    method: 'getPatchApprovalStatusMeta'
  },
  'assetClass.name': {
    method: 'getAssetClassListV2',
    key: 'name'
  },
  'asset.assetClass.name': {
    method: 'getAssetClassListV2',
    key: 'name'
  },
  'workStation.assetClass.name': {
    method: 'getAssetClassListV2',
    key: 'name'
  },
  'owner.name': {
    method: 'getRequesterList',
    key: 'name',
    nestedData: 'userList',
    secondaryMethod: 'userList'
  },
  'requester.name': {
    method: 'getRequesterList',
    key: 'name',
    nestedData: 'userList',
    secondaryMethod: 'userList'
  },
  'filteredSoftware.softwareName': {
    method: 'getAssetSoftwareNamesList',
    key: 'name'
  }
};

const assetGroupApiMethodAndKeyNames = {
  name: {
    method: 'getAssetList',
    key: 'name',
    nestedKey: 'assets',
    uniqueKey: 'id'
  },
  department: {
    method: 'getBusinessFunctionList',
    key: 'name'
  },
  'department.name': {
    method: 'getBusinessFunctionList',
    key: 'name'
  },
  'client.accountId': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients',
    uniqueKey: 'accountId'
  },
  'site.id': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites',
    uniqueKey: 'id'
  },
  'client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients',
    uniqueKey: 'accountId'
  },
  'site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites',
    uniqueKey: 'id'
  },
  assetId: {
    method: 'getAssetListV2',
    key: 'name',
    nestedKey: 'assets',
    uniqueKey: 'assetId'
  },
  'assetClass.name': {
    method: 'getMonitoredAssetClassList',
    key: 'name'
  }
};

const patchApiMethodAndKeyNames = {
  category: {
    method: 'getPatchAllCategorySeverityMeta',
    key: 'generalMeta'
  },
  'workStation.client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  'patchDetail.category': {
    method: 'getPatchAllCategorySeverityMeta',
    key: 'generalMeta'
  },
  severity: {
    method: 'getPatchAllCategorySeverityMeta',
    key: 'generalMeta'
  },
  'patchDetail.severity': {
    method: 'getPatchAllCategorySeverityMeta',
    key: 'generalMeta'
  },
  account: {
    method: 'getClientList',
    key: 'name',
    values: 'clients'
  },
  site: {
    method: 'getClientSiteList',
    key: 'name'
  },
  approvalStatus: {
    method: 'getPatchApprovalStatusMeta'
  },
  'patchDetail.approvalStatus': {
    method: 'getPatchApprovalStatusMeta'
  },
  'assetClass.name': {
    method: 'getMonitoredAssetClassList',
    key: 'name'
  },
  'workStation.site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  }
};

const assetPatchApiMethodAndKeyNames = {
  'patchDetail.category': {
    method: 'getPatchAllCategorySeverityMeta',
    key: 'generalMeta'
  },
  'patchDetail.severity': {
    method: 'getPatchAllCategorySeverityMeta',
    key: 'generalMeta'
  }
};

const policyApiMethodAndKeyNames = {
  'policy.policyType': {
    method: 'getPolicyTypes',
    key: 'name'
  }
};

const scriptApiMethodAndKeyNames = {
  language: {
    method: 'getScriptsMetaV2',
    key: 'name',
    values: 'scriptOptionsMeta',
    subValues: 'scriptLanguages'
  },
  runAs: {
    method: 'getScriptsMetaV2',
    key: 'name',
    values: 'scriptOptionsMeta',
    subValues: 'runAs'
  },
  addedBy: {
    method: 'getTechnicianList',
    secondaryMethod: 'userList',
    key: 'name'
  },
  tags: {
    method: 'getAllCommunityTags',
    key: 'tags'
  }
};

const communityScriptApiMethodAndKeyNames = {
  language: {
    method: 'getScriptsMetaV2',
    key: 'name',
    values: 'scriptOptionsMeta',
    subValues: 'scriptLanguages'
  },
  runAs: {
    method: 'getScriptsMetaV2',
    key: 'name',
    values: 'scriptOptionsMeta',
    subValues: 'runAs'
  },
  addedBy: {
    method: 'getTechnicianList',
    secondaryMethod: 'userList',
    key: 'name'
  },
  tags: {
    method: 'getAllCommunityTags',
    key: 'tags'
  },
  name: {
    method: 'getCommunityLibraryScripts',
    key: 'name'
  }
};

const discoverAssetsApiMethodAndKeyNames = {
  'credential.name': {
    method: 'getNetworkCredentialList',
    key: 'name',
    nestedKey: 'credentials'
  }
};

const clientApiMethodAndKeyNames = {
  status: {
    method: 'getField',
    nestedKey: 'options',
    secondaryMethod: 'options',
    key: 'value'
  },
  stage: {
    method: 'getField',
    nestedKey: 'options',
    secondaryMethod: 'options',
    key: 'value'
  },
  name: {
    method: 'getClientList',
    secondaryMethod: 'clients',
    key: 'name',
    nestedKey: 'clients'
  },
  getRequesterName: {
    method: 'getRequesterList',
    key: 'name',
    nestedKey: 'userList'
  },

  'primaryContact.name': {
    method: 'getRequesterList',
    key: 'name',
    nestedKey: 'userList',
    secondaryMethod: 'userList'
  },
  'secondaryContact.name': {
    method: 'getRequesterList',
    key: 'name',
    nestedKey: 'userList',
    secondaryMethod: 'userList'
  },
  'primaryContact.email': {
    method: 'getRequesterList',
    key: 'email',
    nestedKey: 'userList',
    secondaryMethod: 'userList'
  },
  'secondaryContact.email': {
    method: 'getRequesterList',
    key: 'email',
    nestedKey: 'userList',
    secondaryMethod: 'userList'
  },
  'accountManager.name': {
    method: 'getTechnicianList',
    key: 'name',
    nestedKey: 'userList',
    secondaryMethod: 'userList'
  },
  'accountManager.email': {
    method: 'getTechnicianList',
    key: 'email',
    nestedKey: 'userList',
    secondaryMethod: 'userList'
  },
  getTechName: {
    method: 'getTechnicianList',
    key: 'name',
    nestedKey: 'userList'
  },
  getRequesterEmail: {
    method: 'getRequesterList',
    key: 'email',
    nestedKey: 'userList',
    secondaryMethod: 'userList'
  },
  getTechEmail: {
    method: 'getTechnicianList',
    key: 'email',
    nestedKey: 'userList'
  },
  'site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  }
};

const siteApiMethodAndKeyNames = {
  name: {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  }
};

const ownerApiMethodAndKeyNames = {
  name: {
    method: 'getTechnicianList',
    secondaryMethod: 'userList',
    key: 'name'
  }
};
const apiMethodAndKeyNames = {
  status: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  department: {
    method: 'getBusinessFunctionList',
    key: 'name'
  },
  'department.name': {
    method: 'getBusinessFunctionList',
    key: 'name'
  },
  'businessFunction.name': {
    method: 'getBusinessFunctionList',
    key: 'name'
  },
  'designation.name': {
    method: 'getDesignationList',
    key: 'name'
  },
  approvalStatus: {
    method: 'getTicketApprovalStatus',
    key: 'name'
  },
  priority: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  impact: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  urgency: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  category: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  subcategory: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  cause: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  subcause: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  resolutionCode: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  ticketType: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  client: {
    method: 'getClientList',
    key: 'clients',
    nestedKey: 'name'
  },
  site: {
    method: 'getClientSiteList',
    key: 'name',
    secondaryMethod: 'sites'
  },
  'site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  },
  'client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  'ticket.site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  },
  'ticket.client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  technician: {
    method: 'getAllowedTechnicianGroups',
    key: 'name',
    // secondaryMethod: 'userList',
    customKeys: ['userId']
  },
  techGroup: {
    method: 'getAllowedTechnicianGroups',
    key: 'name',
    customKeys: ['groupId']
  },
  'techGroup.name': {
    method: 'getTechnicianGroups',
    key: 'name'
  },
  sop: {
    method: 'getAllSOPs',
    key: 'name'
  },
  RUNBOOK: {
    method: 'getRunbooks',
    secondaryMethod: 'runbook',
    key: 'name'
  },
  stage: {
    method: 'getClientStages',
    key: 'name'
  },
  source: {
    method: 'getAllSource',
    key: 'name'
  },
  'project.status': {
    method: 'getWorkStatuses',
    key: 'name'
  },
  'project.techGroup.name': {
    method: 'getTechnicianGroups',
    key: 'name'
  },
  'ticket.techGroup.name': {
    method: 'getTechnicianGroups',
    key: 'name'
  },
  'worklog.client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  'ticket.status': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.approvalStatus': {
    method: '',
    key: 'name'
  },
  'ticket.priority': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.impact': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.urgency': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.category': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.subcategory': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.cause': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.subcause': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.resolutionCode': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.ticketType': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'ticket.sop': {
    method: 'getAllSOPs',
    key: 'name'
  },
  'ticket.source': {
    method: 'getAllSource',
    key: 'name'
  },
  'serviceItem.name': {
    method: 'getServiceItems',
    key: 'name',
    nestedKey: 'items'
  },
  module: {
    method: 'getWorklogModules'
  },
  team: {
    method: 'getTeamList',
    key: 'name'
  },
  businessFunction: {
    method: 'getBusinessFunctionList',
    key: 'name'
  },
  designation: {
    method: 'getDesignationList',
    key: 'name'
  },
  reportingManager: {
    method: 'getCompanyUsersList',
    secondaryMethod: 'userList',
    key: 'name'
  },
  roles: {
    method: 'getTechnicianRoleTypeRoles',
    key: 'name'
  },
  'ticket.form': {
    method: 'getPublishedTicketForms',
    key: 'formName'
  }
};

const provisionRuleApiMethodAndKeyNames = {
  name: {
    method: 'getClientProvisionRuleList',
    secondaryMethod: 'provisionRules',
    key: 'name'
  },
  'name.in.template': {
    method: 'getProvisionRuleTemplateList',
    secondaryMethod: 'provisionRules',
    key: 'name'
  }
};

const paymentMethodApiMethodAndKeyNames = {
  paymentMethodName: {
    method: 'getPaymentMethods',
    key: 'paymentMethodName'
  }
};
const invoicePaymentTermApiMethodAndKeyNames = {
  paymentTermName: {
    method: 'getPaymentTerms',
    key: 'paymentTermName'
  }
};

const invoiceApiMethodAndKeyNames = {
  statusEnum: {
    method: 'getInvoiceStatus'
  },
  pushedToIntegratedAppStatus: {
    method: 'getThirdPartyIntegratedAppStatus'
  }
};

const offeredItemApiMethodAndKeyNames = {
  'client.name': {
    method: 'getClientList',
    key: 'name',
    nestedKey: 'clients'
  },
  'site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  },
  'serviceItem.name': {
    method: 'getServiceItems',
    key: 'name',
    nestedKey: 'items'
  },
  'serviceCatalogItem.name': {
    method: 'getServiceCatalogItems',
    key: 'name',
    nestedKey: 'items'
  },
  status: {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'technician.email': {
    method: 'getTechnicianList',
    key: 'name',
    nestedKey: 'userList'
  },
  'technician.name': {
    method: 'getTechnicianList',
    key: 'email',
    nestedKey: 'userList'
  },
  'ticket.status': {
    method: 'getField',
    secondaryMethod: 'options',
    key: 'value'
  },
  'project.status': {
    method: 'getWorkStatuses',
    key: 'name'
  },
  offeredItemModule: {
    method: 'getOfferedItemModules'
  },
  worklogModule: {
    method: 'getWorklogModules'
  },
  module: {
    method: 'getWorklogModules'
  }
};

const whiteListedServiceItemApiMethodAndKeyName = {
  'serviceItem.name': {
    method: 'getWhitelistedServiceItems',
    secondaryMethod: 'items',
    key: 'name',
    nestedKey: 'items'
  },
  'serviceCatalogItem.name': {
    method: 'getEligibleServiceCatalogItems',
    secondaryMethod: 'items',
    key: 'name',
    nestedKey: 'items'
  }
};

const requesterApiMethodAndKeyNames = {
  'site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  },
  'associations.site.name': {
    method: 'getClientSiteList',
    key: 'name',
    nestedKey: 'sites'
  }
};

const technicianGroupApiMethodAndKeyNames = {
  name: {
    method: 'getTechnicianGroups',
    key: 'name'
  }
};

const assetClassApiMethodAndKeyNames = {
  name: {
    method: 'getAssetClassListV2',
    key: 'name'
  }
};

const getApiMethodAndKeyNames = (module) => {
  switch (module) {
    case 'Project':
      return projectApiMethodAndKeyNames;
    case 'PaymentMethod':
      return paymentMethodApiMethodAndKeyNames;
    case 'InvoicePaymentTerm':
      return invoicePaymentTermApiMethodAndKeyNames;
    case 'Patch':
      return patchApiMethodAndKeyNames;
    case 'AssetPatch':
    case 'patch-associated-asset':
      return assetPatchApiMethodAndKeyNames;
    case 'Policy':
      return policyApiMethodAndKeyNames;
    case 'Alert':
      return alertApiMethodAndKeyNames;
    case 'Asset':
    case 'NMAsset':
    case 'AllAssets':
      return assetApiMethodAndKeyNames;
    case 'AssetClass':
      return assetClassApiMethodAndKeyNames;
    case 'AssetGroup':
      return assetGroupApiMethodAndKeyNames;
    case 'Script':
      return scriptApiMethodAndKeyNames;
    case 'CommunityScript':
      return communityScriptApiMethodAndKeyNames;
    case 'Task':
      return taskApiMethodAndKeyNames;
    case 'Client':
      return clientApiMethodAndKeyNames;
    case 'Invoice':
      return invoiceApiMethodAndKeyNames;
    case 'OfferedItem':
      return offeredItemApiMethodAndKeyNames;
    case 'whiteListedServiceItem':
      return whiteListedServiceItemApiMethodAndKeyName;
    case 'DiscoveredAssets':
      return discoverAssetsApiMethodAndKeyNames;
    case 'Site':
      return siteApiMethodAndKeyNames;
    case 'Requester':
      return requesterApiMethodAndKeyNames;
    case 'ProvisionRule':
      return provisionRuleApiMethodAndKeyNames;
    case 'TechnicianGroup':
      return technicianGroupApiMethodAndKeyNames;
    case 'ProjectOwner':
      return ownerApiMethodAndKeyNames;
    default:
      return apiMethodAndKeyNames;
  }
};

export { apiResolver, apiMethodAndKeyNames, getApiMethodAndKeyNames };
